/**
 * Strip TipTap / HTML markup for tooltips and other plain-text-only surfaces.
 */
export function htmlToPlainText(value: unknown): string {
  if (value == null) {
    return '';
  }

  let text = String(value);
  text = text.replace(/\r\n/g, '\n');
  text = text.replace(/<\s*br\s*\/?\s*>/gi, '\n');
  text = text.replace(/<\/\s*p\s*>/gi, '\n');
  text = text.replace(/<\s*li[^>]*>/gi, '\n• ');
  text = text.replace(/<\/\s*li\s*>/gi, '');
  text = text.replace(/<[^>]+>/g, '');
  text = text
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'");
  text = text.replace(/\n{3,}/g, '\n\n');
  return text.trim();
}
